import { Input, Popover } from '@thimble/core-lib';
import React, { useRef, useState } from 'react';
import { useUpdateEffect } from 'react-use';
import { apiZipcodeSarch } from '../apis/zipcode';
import ICInput from '../atoms/ICInput';
import Spin from '../atoms/Spin';
import useRequest from '../hooks/useRequest';
import { PopupPreset } from '../utils/popupPreset';

type ZipcodeAndStateControlProps = {
  value?: [string, string] | null;
  onChange?: (value: [string, string] | null) => void;
};

const noop = () => {};

const ZipcodeAndStateControl: React.FC<ZipcodeAndStateControlProps> = ({
  value,
  onChange = noop,
}) => {
  const [{ value: states, loading: statesLoading }, triggerZipcodeSearch, clearZipcodeSearch] =
    useRequest(apiZipcodeSarch);

  const [query, setQuery] = useState('');

  const lastQuery = useRef(query);

  useUpdateEffect(() => {
    if (query.length === 5) {
      triggerZipcodeSearch((lastQuery.current = query)).then(states => {
        if (states.length === 0) {
          onChange([query, '']);
          clearZipcodeSearch();
        } else if (states.length === 1) {
          onChange([query, states[0]]);
          clearZipcodeSearch();
        }
      });
    } else if (query.length === 0) clearZipcodeSearch();
  }, [query]);

  return (
    <>
      <Popover
        visible={statesLoading || (states && states.length >= 2)}
        popup={
          <div style={{ fontSize: 16 }}>
            {statesLoading ? (
              <Spin />
            ) : states && states.length >= 2 ? (
              states.map(state => (
                <div
                  key={state}
                  onClick={() => {
                    onChange([lastQuery.current, state]);
                    clearZipcodeSearch();
                  }}
                  className="insurance-calculator-widget__pop-option"
                >
                  {state}
                </div>
              ))
            ) : null}
          </div>
        }
        popupPreset={PopupPreset}
      >
        <ICInput
          label={['ZIP Code', null]}
          placeholder="90402"
          value={value?.[0] ? `${value[0]} (${value[1]})` : query}
          onChange={value ? undefined : setQuery}
          readOnly={!!value}
          clearable
          onClear={
            value
              ? () => {
                  setQuery('');
                  onChange(null);
                }
              : undefined
          }
        />
      </Popover>
    </>
  );
};

export default ZipcodeAndStateControl;
